import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme) => ({
  /* rem good for greater than 16px */
  inputContainer: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    '&:hover': {
      border: 'none',
    },
    border: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  },
  input: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',

    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
    },

    backgroundColor: colors.white,
  },
  locationInputContainer: {
    [theme.breakpoints.between(960, 1100)]: {
      flex: '40%',
    },
  },
  locationInput: {
    '&::placeholder': {
      opacity: '.5',
    },
    '&:focus-visible': {
      outline: 'none',
    },
  },
  searchBar: {
    width: '300px',
  },
}));
